export default __webpack_public_path__ + "static/media/2415.ea13c341.png";